import React, { useState } from "react";
import "./RewardsTickHomePage.scss"
import hero from "../image/hero-bg.jpg"
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
import apple from "../image/apple.svg"
import playstore from "../image/playstore.svg"
import image from "../image/hero-image.jpg"


const RewardsTickHeroPage = () => {

    return (
        <div className="RewardsTickHeroPage" style={{
            background: `linear-gradient(135deg, #05966893 0%, #0f766e 100%), url(${image})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
        }}>
            <div className="RewardsTickHeroPage-inner">
                <div className="RewardsTickHeroPage-inner-left">
                    <HeaderText
                        text={"Shop, Earn and Get Rewarded!"}
                        invert />
                    <div className="RewardsTickHeroPage-subheader">
                        <SubheaderText
                            text={"Discover amazing deals while earning rewards on every purchase. Transform your shopping experience with our innovative rewards system."}
                            invert
                        />
                    </div>
                    <div className="RewardsTickHeroPage-btncont">
                        <div className="RewardsTickHeroPage-down">
                            <img alt="" src={apple} />
                            <div className="RewardsTickHeroPage-down-cont">
                                <div className="RewardsTickHeroPage-down-cont-subheader">
                                    Download on the
                                </div>
                                <div className="RewardsTickHeroPage-down-cont-header">
                                    App Store
                                </div>
                            </div>
                        </div>
                        <div className="RewardsTickHeroPage-down">
                            <img alt="" src={playstore} />
                            <div className="RewardsTickHeroPage-down-cont">
                                <div className="RewardsTickHeroPage-down-cont-subheader">
                                    Get it on
                                </div>
                                <div className="RewardsTickHeroPage-down-cont-header">
                                    Google Play
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="RewardsTickHeroPage-inner-right">
                    <img alt="" src={hero} />
                </div>
            </div>
        </div>
    )
}
export default RewardsTickHeroPage